/**
 * Schema of WhatsappStatus
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import WhatsappStatus from '@/model/resource/WhatsappStatus'

export default (model: WhatsappStatus): Schema => ({
  idWhatsappStatusPk: {
    content: model.idWhatsappStatusPk,
    editable: false,
  },

  nome: {
    content: model.nome,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  ativo: {
    content: bool(model.ativo),
    hidden: true,
    editable: false,
  },
})
